import React, { FC } from 'react'

import { useGpsUnits, useZonesList } from 'modulesCommon/serviceHooks'
import { ArtistHeader, ArtistTable } from 'modules/Artists/components'
import { useLoading } from 'shared/hooks'
import { LoadMore } from 'components'
import { useServerError } from 'shared/hooks'
import { useArtists } from '../serviceHooks/useArtists'

const ArtistListContainer: FC = () => {
  const { zoneList } = useZonesList()
  const { artistsLoading, artistsError, artists, total, increaseUsersOffset, onSearchArtist } = useArtists()
  const { gpsUnitsLoading, gpsUnitsError, gpsUnits } = useGpsUnits()

  useLoading({ isLoading: artistsLoading || gpsUnitsLoading })
  useServerError([artistsError, gpsUnitsError])

  return (
    <>
      <ArtistHeader loading={artistsLoading} onSearch={onSearchArtist}/>
      <ArtistTable artistList={artists} labels={zoneList} gpsUnits={gpsUnits} />
      <LoadMore
        label="artists on Storybox"
        onLoad={increaseUsersOffset}
        isItemsLoading={artistsLoading}
        itemsTotal={total}
        itemsCount={artists.length}
      />
    </>
  )
}

export default ArtistListContainer
